import { defineMessages } from 'react-intl';

export default defineMessages({
  postPaymentsAndDeposits: {
    id: 'postPaymentsAndDepositsModal.postPaymentsAndDeposits',
    defaultMessage: 'Post Payments & Deposits',
  },
  disabledTooltip: {
    id: 'postPaymentsAndDepositsModal.disabledTooltip',
    defaultMessage: 'This Voucher has already been marked as Paid.',
  },
  modalTitle: {
    id: 'postPaymentsAndDepositsModal.modalTitle',
    defaultMessage: 'Post Payments & Deposits',
  },
  confirmationMessage: {
    id: 'postPaymentsAndDepositsModal.confirmationMessage',
    defaultMessage: 'Are you sure you want to mark this Voucher as Paid?',
  },
  cancel: {
    id: 'postPaymentsAndDepositsModal.cancel',
    defaultMessage: 'Cancel',
  },
  confirm: {
    id: 'postPaymentsAndDepositsModal.confirm',
    defaultMessage: 'Confirm',
  },
  toastrSuccess: {
    id: 'postPaymentsAndDepositsModal.toastrSuccess',
    defaultMessage: 'Voucher has been marked as Paid.',
  },
  toastrError: {
    id: 'postPaymentsAndDepositsModal.toastrError',
    defaultMessage: 'Failed to mark Voucher as Paid. Please try again.',
  },
});
